'use strict'
import GeoJSON from 'ol/format/GeoJSON'
import { get as getProjection } from 'ol/proj'
import Polygon from 'ol/geom/Polygon'
import Feature from 'ol/Feature'

const GeoJson = new GeoJSON({
  dataProjection: getProjection('epsg:2056'),
  featureProject: getProjection('epsg:2056')
})

const convertMutliPolygonToFeatureCollection = (geom) => {
  if (typeof geom === 'undefined') return null
  if (geom === '') return null

  let toReturn = []
  let rawGeoJSON = JSON.parse(geom)

  rawGeoJSON.coordinates.forEach(c => {
    toReturn.push(new Feature(new Polygon(c)))
  })

  return GeoJson.writeFeatures(toReturn)
}

export {
  GeoJson as GeoJSON,
  convertMutliPolygonToFeatureCollection
}
